import { Component, Input, OnDestroy, OnInit,AfterViewInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription, Subject} from 'rxjs';
import { AccountEstatementsService } from '../_services/estatements.services';
import { HelperServices } from '../_services/helper.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Document } from '../_models/document.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { BiM1 } from '../_models/bi.model';


@Component({
  selector: 'app-list-estatements',
  templateUrl: './list-estatements.component.html',
  styleUrls: ['./list-estatements.component.scss']
})
export class ListEstatementsComponent implements OnInit, OnDestroy, AfterViewInit {
  isLoading: boolean;
  loadingModalConfig: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };
  templateView: number = 1;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  uplodaTypedocument: number = 0;
  document_selected: Document;
  closeResult: string;
  model: NgbDateStruct;
  date: {year: number, month: number};
  filterForm: FormGroup;
  filterComisionesForm: FormGroup;
  filterInvoicesForm: FormGroup;
  filterDelinquencyForm: FormGroup;
  filterPagosForm: FormGroup;
  filterClaims2Form: FormGroup;
  filterSolicitudesForm: FormGroup;
  filterDateEndForm: FormGroup;
  filterSolicitudesDateEndForm: FormGroup;
  otherReportForm: FormGroup;
  user$: Observable<UserModel>;
  _user: UserModel;
  hasError: boolean;
  itemsReportComision: any;
  meses: any;
  anyos: any;
  tipoReporte: any;
  asbiM1HTML$ = new BehaviorSubject(false);
  biM1HTMLShow = false;
  permissionMenu: any;
  public biM1HTML: BiM1; /*{
    ReporteBI : "",
    NombreReporte : "",
    IdAplicaReporteBI : 0,
    ReportWidth : 0,
    ReportHeight : 0
  };*/


  constructor(
    public estatementService: AccountEstatementsService,
    private layout: LayoutService,
    private auth: AuthService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private modalLoading: NgbModal,
    public helperService: HelperServices
  ) {
    
  }

  ngAfterViewInit() {
    this.initForm();

  }

 // angular lifecircle hooks
  async ngOnInit() {
    this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];

    await this.estatementService.getReportBiM1("").then(biM1HTML => {
      if(typeof biM1HTML.IdAplicaReporteBI != undefined) {
        this.biM1HTML = biM1HTML[0];
        this.asbiM1HTML$.next(biM1HTML.IdAplicaReporteBI == 1 ? true : false);

        console.log(this.biM1HTML.NombreReporte);
      }
    });

    /*
    const sb1 = this.documentService.isLoading$.subscribe(res => this.isLoading = res);
    const sb2 = this.documentService.isLoading$.subscribe(res => this.isLoading = res);
    this.subscriptions.push(sb1);
    this.subscriptions.push(sb2);
    this.documentService.fetch();
    */

    this.asbiM1HTML$.subscribe( res => {
      this.biM1HTMLShow = res;
    });

    this.user$ = this.auth.currentUserSubject.asObservable();
    this.user$.subscribe(user=> {
      this._user = user;
    });

    this.meses = this.helperService.getMeses();
    this.anyos = this.helperService.getAnyos();
    this.tipoReporte = this.estatementService.getTipoReporte();
  }

  showBI() {

  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  async clickView(id = 0, _templateView = 1) {
    var _this = this;


    switch ((this.templateView = _templateView)) {
        case 1:
            this.templateView = _templateView;
        break;

        case 2:
        case 4:
        case 6:
        case 7:
        case 8:
        case 9:
        this.resetFilterForm();
        this.templateView = _templateView;
        break;

        case 5:
        this.resetFilterForm(false,false,true);
        this.templateView = _templateView;
        break;
    }
  }

  initForm() {

    this.filterForm = this.fb.group({
      inputMes: [''],
      inputAnyo: [''],
      inputDocument: ['', Validators.compose([Validators.required]) ],
    });

    this.filterComisionesForm = this.fb.group({
      inputMes: ['', Validators.compose([Validators.required]) ],
      inputAnyo: ['', Validators.compose([Validators.required]) ],
      inputDocument: ['', Validators.compose([Validators.required]) ],
    });

    this.filterPagosForm = this.fb.group({
      inputMes: ['', Validators.compose([Validators.required]) ],
      inputAnyo: ['', Validators.compose([Validators.required]) ],
      inputDocument:['', Validators.compose([Validators.required]) ],
    });

    this.filterInvoicesForm = this.fb.group({
      inputMes: ['', Validators.compose([Validators.required]) ],
      inputAnyo: ['', Validators.compose([Validators.required]) ],
      inputDocument:['', Validators.compose([Validators.required]) ],
    });

    this.filterDelinquencyForm = this.fb.group({
      //inputMes: ['', Validators.compose([Validators.required]) ],
      //inputAnyo: ['', Validators.compose([Validators.required]) ],
      inputDocument:['', Validators.compose([Validators.required]) ],
    });

    this.filterSolicitudesForm = this.fb.group({
        inputMes: ['', Validators.compose([Validators.required]) ],
        inputAnyo: ['', Validators.compose([Validators.required]) ],
        inputDocument:['', Validators.compose([Validators.required]) ],
    });

    this.filterDateEndForm = this.fb.group({
        inputFechaHasta: ['', Validators.compose([Validators.required]) ],
        inputDocument:['', Validators.compose([Validators.required]) ],
    });

    this.filterSolicitudesDateEndForm = this.fb.group({
        inputFechaHasta: ['', Validators.compose([Validators.required]) ],
        inputDocument:['', Validators.compose([Validators.required]) ],
    });

    this.otherReportForm = this.fb.group({
        inputFechaDesde: ['', Validators.compose([Validators.required]) ],
        inputFechaHasta: ['', Validators.compose([Validators.required]) ],
        inputTypeReport: ['', Validators.compose([Validators.required]) ],
        inputDocument:['', Validators.compose([Validators.required]) ],
    });
  }

  resetFilterForm(inputMes=true, inputAnyo=true,inputDocument=true) {
    this.filterForm.controls['inputMes'].clearValidators();   
    this.filterForm.controls['inputAnyo'].clearValidators();   
    this.filterForm.controls['inputDocument'].clearValidators();   

    this.filterForm.patchValue({
      inputMes: '',
      inputAnyo: '',
      inputDocument: ''
    });
    if(inputAnyo) {
      this.filterForm.controls['inputAnyo'].setValidators(Validators.required);   
    }
    if(inputMes) {
      this.filterForm.controls['inputMes'].setValidators(Validators.required);   
    }
    if(inputDocument) {
      this.filterForm.controls['inputDocument'].setValidators(Validators.required);   
    }
  }

  openModalSales(content) {
    this.modalService.open(content, this.loadingModalConfig).result.then((result) => {
        
    }, (reason) => { // ESC, BACKDROP_CLICK
        
    });
  }

  async downloadDocument(data, filename, type) {
    this.helperService.printPreview(data, filename, type);
  }

  private submitFilterComisiones(content, filename="reporte-de-comision") {

    this.modalLoading.open(content, this.loadingModalConfig);

      this.estatementService.getEstadoCuentaComisiones(Array(`TipoDoc=${this.filterForm.value.inputDocument}`,`Ano=${this.filterForm.value.inputAnyo}`, `Mes=${this.filterForm.value.inputMes}`).join("&")).then((response : any) => {

        if(parseInt(this.filterForm.value.inputDocument) == 1) {
          this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
        else if(parseInt(this.filterForm.value.inputDocument) == 2){
          this.helperService.printPreview2(response, `${filename}.pdf`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
      }).finally(() => {
        this.modalLoading.dismissAll();
      }).catch(() => {
        this.modalLoading.dismissAll();
      });
  }

   private submitFilterPagos(content, filename="reporte-listado-pagos-aplicados") {

    this.modalLoading.open(content, this.loadingModalConfig);

      this.estatementService.getListadoPagosAplicados(Array(`TipoDoc=${this.filterForm.value.inputDocument}`,`Ano=${this.filterForm.value.inputAnyo}`, `Mes=${this.filterForm.value.inputMes}`).join("&")).then((response) => {
        if(parseInt(this.filterForm.value.inputDocument) == 1) {
          console.log(response);
          this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
        else if(parseInt(this.filterForm.value.inputDocument) == 2){
          this.helperService.printPreview2(response, `${filename}.pdf`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
      }).finally(() => {
        this.modalLoading.dismissAll();
      }).catch(() => {
        this.modalLoading.dismissAll();
      });
  }
  
   submitFilterInvoices(content, filename="reporte-de-listado-facturas") {

    this.modalLoading.open(content, this.loadingModalConfig);

      this.estatementService.getInvoices(Array(`TipoDoc=${this.filterForm.value.inputDocument}`,`Ano=${this.filterForm.value.inputAnyo}`, `Mes=${this.filterForm.value.inputMes}`).join("&")).then((response) => {
        if(parseInt(this.filterForm.value.inputDocument) == 1) {
          this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
        else if(parseInt(this.filterForm.value.inputDocument) == 2){
          this.helperService.printPreview2(response,`${filename}.pdf`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
      }).finally(() => {
        this.modalLoading.dismissAll();
      }).catch(() => {
        this.modalLoading.dismissAll();
      });
  }

  submitFilterDelinquency(content, filename="reporte-de-listado-morosidad") {

    this.modalLoading.open(content, this.loadingModalConfig);

      this.estatementService.getDelinquency(Array(`TipoDoc=${this.filterForm.value.inputDocument}`).join("&"), ).then((response : any) => {
        if(parseInt(this.filterForm.value.inputDocument) == 1) {
          this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
        else if(parseInt(this.filterForm.value.inputDocument) == 2){
          this.helperService.printPreview2(response, `${filename}.pdf`, this.getType(parseInt(this.filterForm.value.inputDocument)));
        }
      }).finally(() => {
        this.modalLoading.dismissAll();
      }).catch(() => {
        this.modalLoading.dismissAll();
      });
  }

  public submitClaimsFilter(content, filename="reporte-listado-reclamos") {

    this.modalLoading.open(content, this.loadingModalConfig);

    var paramsGet = [];

    if( typeof(this.filterDateEndForm.value.inputFechaHasta) == 'object' && this.filterDateEndForm.value.inputFechaHasta != null) {
        if(this.filterDateEndForm.value.inputFechaHasta.year){
            let date2 = Array(this.filterDateEndForm.value.inputFechaHasta.year,this.filterDateEndForm.value.inputFechaHasta.month,this.filterDateEndForm.value.inputFechaHasta.day).join('/')
            paramsGet.push(`FechaDesde=${date2}`);
            paramsGet.push(`FechaHasta=${date2}`);
        }

        paramsGet.push(`TipoDoc=${this.filterDateEndForm.value.inputDocument}`);

        this.estatementService.getListadoReclamos(paramsGet.join('&')).then((response : any) => {
            if(parseInt(this.filterDateEndForm.value.inputDocument) == 1) {
            this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.filterDateEndForm.value.inputDocument)));
            }
            else if(parseInt(this.filterDateEndForm.value.inputDocument) == 2){
            this.helperService.printPreview2(response, `${filename}.pdf`, this.getType(parseInt(this.filterDateEndForm.value.inputDocument)));
            }
        }).finally(() => {
            this.modalLoading.dismissAll();
        }).catch(() => {
            this.modalLoading.dismissAll();
        });
    }
  }

  public submitSolicitudesFilter(content, filename="reporte-listado-solicitudes") {

    this.modalLoading.open(content, this.loadingModalConfig);

    var paramsGet = [];

    if( typeof(this.filterSolicitudesDateEndForm.value.inputFechaHasta) == 'object' && this.filterSolicitudesDateEndForm.value.inputFechaHasta != null) {
        if(this.filterSolicitudesDateEndForm.value.inputFechaHasta.year){
            let date2 = Array(this.filterSolicitudesDateEndForm.value.inputFechaHasta.year,this.filterSolicitudesDateEndForm.value.inputFechaHasta.month,this.filterDateEndForm.value.inputFechaHasta.day).join('/')
            paramsGet.push(`FechaDesde=${date2}`);
            paramsGet.push(`FechaHasta=${date2}`);
        }

        paramsGet.push(`TipoDoc=${this.filterSolicitudesDateEndForm.value.inputDocument}`);

        this.estatementService.getListadoSolicitudes(paramsGet.join('&')).then((response : any) => {
            if(parseInt(this.filterSolicitudesDateEndForm.value.inputDocument) == 1) {
            this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.filterSolicitudesDateEndForm.value.inputDocument)));
            }
            else if(parseInt(this.filterSolicitudesDateEndForm.value.inputDocument) == 2){
            this.helperService.printPreview2(response, `${filename}.pdf`, this.getType(parseInt(this.filterSolicitudesDateEndForm.value.inputDocument)));
            }
        }).finally(() => {
            this.modalLoading.dismissAll();
        }).catch(() => {
            this.modalLoading.dismissAll();
        });
    }
  }

  public submitOtherReportForm(content, filename="reporte-otros") {
    var paramsGet = [];

    if(this.otherReportForm.valid) {
        this.modalLoading.open(content, this.loadingModalConfig);

        if(typeof(this.otherReportForm.value.inputFechaDesde) == 'object' && this.otherReportForm.value.inputFechaDesde != null){
            let date1 = Array(this.otherReportForm.value.inputFechaDesde.year,this.otherReportForm.value.inputFechaDesde.month,this.otherReportForm.value.inputFechaDesde.day).join('/')
            paramsGet.push(`FechaDesde=${date1}`);
        }

        if(typeof(this.otherReportForm.value.inputFechaHasta) == 'object' && this.otherReportForm.value.inputFechaHasta != null){
            let date2 = Array(this.otherReportForm.value.inputFechaHasta.year,this.otherReportForm.value.inputFechaHasta.month,this.otherReportForm.value.inputFechaHasta.day).join('/')
            paramsGet.push(`FechaHasta=${date2}`);
        }

        paramsGet.push(`IdReporte=${this.otherReportForm.value.inputTypeReport}`);
        paramsGet.push(`TipoDoc=${this.otherReportForm.value.inputDocument}`);

        this.estatementService.getReportesOtros(paramsGet.join('&')).then((response : any) => {
            if(parseInt(this.otherReportForm.value.inputDocument) == 1) {
                this.helperService.printPreview2(response, `${filename}.xlsx`, this.getType(parseInt(this.otherReportForm.value.inputDocument)));
            }
            else if(parseInt(this.otherReportForm.value.inputDocument) == 2){
                this.helperService.printPreview2(response, `${filename}.pdf`, this.getType(parseInt(this.otherReportForm.value.inputDocument)));
            }
        }).finally(() => {
            this.modalLoading.dismissAll();
        }).catch(() => {
            this.modalLoading.dismissAll();
        });
    }
  }

  submitFilter(content, form) {
    if(this.filterForm.valid){
      switch(form)
      {
        case 1: this.submitFilterComisiones(content); break;
        case 2: this.submitFilterPagos(content); break;
        case 3: this.submitFilterInvoices(content); break;
        case 4: this.submitFilterDelinquency(content); break;
        case 5: this.submitClaimsFilter(content); break;
        case 6: this.submitSolicitudesFilter(content); break;
      }
    }
  }

  getType(t) {
    switch(t) {
      case 1: return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case 2: return "application/pdf";
    }
  }
}